<template>
    <div v-if="!innerIsReview" style="position: relative">
        <validation-provider
            v-slot="{ errors }"
            :name="label || 'This'"
            :rules="rules"
            v-bind="providerProps"
            v-show="innerShouldShow"
            :vid="'validate-' + fieldAssignmentId"
        >
            <div v-if="innerLabel"><h3 class='mt-2 mb-0 ic-label' v-html="innerLabel"></h3></div>
            <span
                    class="field-directions"
                    v-if="directions"
                    v-html="directions"
            ></span>
            <div
                :class="[
                    !isScroll ? 'checkbox-new' : null,
                    'ic-root',
                    !!innerValue ? 'selected' : null
                ]"
            >
                <div class="ic-bg v-input__slot"></div>
                <div
                        id="IronClad"
                        ref="IronClad"
                        :class="[
                                !isScroll ? 'IronClad' : null
                        ]"
                ></div>
                <i
                    aria-hidden="true"
                    :class="[
                        isScroll ? 'hidden' : null,
                        'ic-check v-icon notranslate mdi',
                        innerValue
                            ? 'mt-2 mdi-checkbox-marked primary--text'
                            : 'mt-2 mdi-checkbox-blank-outline'
                    ]"
                ></i>
                <v-text-field
                    class="hidden"
                    v-model="innerValue"
                ></v-text-field>
            </div>
        </validation-provider>
    </div>
    <div v-else>
        <type-review
            v-if="extraProps"
            :label="label"
            :directions="directions"
            :should-show="innerShouldShow"
            :show-edit-button="extraProps.editButton"
            :page-number="extraProps.originalPageNumber"
            @goToPage="goToPage($event)"
        >
            <div v-if="innerValue">
                <span v-html="innerValue"></span>
            </div>
            <div v-else>N/A</div>
        </type-review>
    </div>
</template>

<script>
import formMixin from '../formMixin';
import $api from "@api/api";
import IronClad from '@services/IronClad/api';
import TypeReview from './TypeReview';

export default {
    name: 'TypeSelect',
    mixins: [formMixin],
    components: {
        TypeReview
    },
    data() {
        return {
            templates: [],
            observer: null,
            agreed: ''
        };
    },
    methods: {
        checkToggler() {
            this.innerValue = !this.innerValue;
        },
        handleChildrenChanged() {
            document
                .querySelector('#IronClad input')
                .addEventListener('click', this.checkToggler);
        },
        ironCladDetector() {
            const config = {
                attributes: true,
                attributeList: ['id']
            };
            const callback = mu => {
                this.$nextTick(() => {
                    if (mu[0].target.childNodes.length > 0)
                        this.handleChildrenChanged();
                });
            };

            const observer = new MutationObserver(callback);
            observer.observe(this.$refs.IronClad, config);
            this.observer = observer;
        }
    },
    async mounted() {
        const self = this;
        const userEmail = this.getSiblingValue('user.email'); // should we make this more dynamic?
        const userId = this.getSiblingValue('user.id');
        const userName = this.getSiblingValue('user.name');
        const {data:agreement} = await $api.agreements.getAgreement(this.settings.agreement_id);
        if( agreement ) {
            const group = await IronClad.groups.getGroup(
                    agreement.external_id,
                    userEmail,
                    {container_selector: 'IronClad'}
            );
            if (group) {
                group.render();

                // TODO:: move this logic to the IronClad api. Kind of hacky
                // _ps is a global js object
                _ps.on('valid', function (params, context) {
                    if (params.group === group.parameters?.data?.values[':group'])
                        self.innerValue = "agreed";
                });
                _ps(agreement.external_id + ":retrieveHTML", {fullName: userName, userId, agreementId:agreement.id, agreementAssignmentId:userId});
            }
        }
        this.ironCladDetector();
        this.fieldLoaded(); // signal to the form we are loaded
    },
    computed: {
        defaults() {
            return {
                label: this.innerLabel,
                items: this.value_options || [],
                persistentHint: true
            };
        },
        rules() {
            return (this.enableValidation) ? {
                ...this.validation_settings,
                ...{
                    required:
                        !!this.validation_settings.required &&
                        !!this.innerShouldShow
                }
            } : {};
        },
        isMultiple() {
            return this.type_attributes?.indexOf('Multiple') > -1;
        },
        isScroll() {
            return this.type_attributes?.indexOf('Scroll') > -1;
        }
    },
    beforeDestroy() {
        if (this.observer) this.observer.disconnect();
    },
    watch: {}
};
</script>

<style lang="scss">
@import 'resources/sass/custom/portal/variables/main.scss';

.IronClad {
    // overrides
    margin-top: 8px;
    position: absolute;
    z-index: 1;
    font-weight: 400;

    .ps-checkbox-line {
        margin-left: 15px !important;
    }

    .ps-checkbox {
        height: 20px !important;
        width: 20px !important;
        opacity: 0;
    }
}

#IronClad {

    .ps-contract-label {
        margin-left: 15px !important;
        font-weight: map-get($font-weights, regular) !important;
    }
}

.ps-contract-options {
    border-top-left-radius: 4px !important;
    border-top-right-radius: 4px !important;
}

.ps-checkbox-container {
    border-bottom-left-radius: 4px !important;
    border-bottom-right-radius: 4px !important;
}
</style>

<style lang="scss" scoped>
.ic {
    &-root {
        height: 50px;
    }

    &-label{
        position: absolute;
        right: 0;
        z-index: 2;
    }

    &-bg {
        position: absolute;
        height: 100%;
        top: 0;
        left: 0;
        z-index: 0;
    }

    &-check {
        margin-left: 15px;
    }
}
</style>
